import { FunctionComponent, MouseEvent, useState } from "react"
import { Event } from "../../simulation/types"
import { convertToSeconds, convertToTime } from "../../simulation/utils"
import { MessageColors, MessageTypes } from "../types"

export type MessageProps = {
  time: string
  message: string
  messageType: MessageTypes
  connections?: Event[]
}

const Message: FunctionComponent<MessageProps> = ({
  time,
  message,
  messageType,
  connections,
}) => {
  const hasConnections = connections && connections.length > 0
  const [showConnections, setShowConnections] = useState(false)

  const toggleShowConnections = (e: MouseEvent, show: boolean) => {
    e.preventDefault()
    setShowConnections(show)
  }

  return (
    <div
      className="self-stretch flex-1 flex flex-col items-start justify-start gap-[6px]"
      onMouseLeave={(e) => toggleShowConnections(e, false)}>
      <div className="self-stretch flex flex-row items-center justify-start gap-[8px]">
        <div className="flex-1 relative leading-[24px] font-medium">
          {messageType.valueOf()}
          {hasConnections && (
            <img
              className="h-[10px] px-2 cursor-pointer"
              src="/v3/assets/link.svg"
              onMouseEnter={(e) => toggleShowConnections(e, true)}></img>
          )}
        </div>
        <div className="relative text-xs leading-[18px] text-gray-600">
          {convertToTime(convertToSeconds(time), true)}
        </div>
      </div>
      <div
        className={`${MessageColors[messageType]} self-stretch rounded-tl-none rounded-tr-lg rounded-b-lg overflow-hidden flex flex-row items-center justify-start py-2.5 px-3.5 text-gray-900`}>
        <div className="flex-1 relative leading-[24px] font-medium">
          {message}

          {
            // list connections
            hasConnections && showConnections && (
              <div className="mt-2">
                <span className="font-semibold">Connections</span>
                <ul className="pl-4 list-disc font-xs">
                  {connections?.map((connection) => {
                    return (
                      <li key={`${connection.id}-${connection.elapsedTime}`}>
                        {connection.description} ({connection.elapsedTime})
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default Message
